<template>
  <div class="most-viewed__item">
    <a-link
      :to="generateArticleUrl(article)"
      class="most-viewed__item-text text-body"
    >
      {{ prop('Topic', article) | maxLength(65) }}
    </a-link>
    <a-category v-bind="categoryProps" class="most-viewed__category" />
    <div class="divider"></div>
  </div>
</template>

<script>
import { pathOr, prop } from 'ramda'
import mixins from '@/utils/mixins'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ACategory from 'shared/ACategory'

export default {
  name: 'AMostViewedItem',
  mixins: [mixins.urlGenerators],
  components: { ACategory },
  props: {
    article: propValidator([PROP_TYPES.OBJECT])
  },
  computed: {
    categoryProps() {
      return {
        categoryName: pathOr('', ['CategoryName'], this.article),
        categorySlug: pathOr('', ['CategorySlug'], this.article),
        subcategoryName: pathOr('', ['SubCategoryName'], this.article),
        subcategorySlug: pathOr('', ['SubCategorySlug'], this.article)
      }
    }
  },
  methods: {
    prop
  }
}
</script>

<style lang="scss" scoped>
.most-viewed__item {
  width: 320px;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }

  /deep/ .category {
    margin: 12px 0 22px 0;
  }

  @include tablet {
    width: 100%;

    &:last-child {
      margin-right: 30px;
    }
  }
}

.most-viewed__wrapper .most-viewed__item-text {
  display: block;
  height: 44px;
  overflow: hidden;
}
</style>
